<mat-dialog-content>
  <div class="initialize-exercise-dialog-container">
    <h2 class="initialize-exercise-dialog-heading">{{ "initializeExerciseDialog.heading" | translate }}</h2>
    <div class="animated-icon">
        <mat-progress-spinner diameter="64" mode="indeterminate"></mat-progress-spinner>
    </div>
    <p class="uploading-data-dialog-message">{{ "initializeExerciseDialog.message" | translate }}</p>
  </div>
</mat-dialog-content>